/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
const twilioStyles = {
    // Twilio chatbot
    chatbotErrorColor: '#d11313',
    chatbotErrorHoverColor: '#f53636',
    chatbotBubbleContainerColor: '#f5f8fa',
    chatbotMessageInputColor: '#ECEDF1',
};

const brandsConfig = {
    '18F': {
        id: '1001',
        code: '18F',
        domain: '1800flowers', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 20051, // brand's unique store ID
        catalogId: 13302, // brands have many catalogs,but web has one unique catalog
        description: '1-800-Flowers', // simple description of brand used for alt text
        other: {
            order_service_email: '',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        typography: {
            fontFamily: [
                'museo-sans, "Area Variable", Lato, LatoMedium',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            fontWeightRegular: 500,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},

        presentation_family: 'flower',

        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#201648',
                900: '#201648',
                800: '#342A59',
                700: '#483F6B',
                600: '#5B537C',
                500: '#6F678D',
                400: '#837C9F',
                300: '#9790B0',
                200: '#AAA4C1',
                100: '#BEB9D3',
                50: '#D2CDE4',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#185357', // same as primary
                900: '#185357',
                800: '#2A6364',
                700: '#3D7271',
                600: '#4F827F',
                500: '#61918C',
                400: '#74A199',
                300: '#86B0A6',
                200: '#98C0B4',
                100: '#ABCFC1',
                50: '#BDDFCE',
                contrastText: '#fff',
            },
            global: '#F4F2F7',
            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#F4F2F7',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#597F24',
                red: '#d90059',
                blue: '#371A6E',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',
            buttonBackgroundColor: '#201648',
            buttonBackgroundColorSecondary: '#483F6B',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#201648', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#e8eaec',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorAlert: '#f71548',
            contentColor: '#666666',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#058942',

            black: '#1f1f1b',
            white: '#fff',
            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: '#201648',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            OBHeadingColor: '#663399',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            select: '#646464',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#201648',
            successButton: '#058942',
            submit: '#333333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productTitleColor: '#1f1f1b',
            productAvailibilityPDP: '#a1001a',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            mobileMenuColor: '#fff',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#201648',
            modalBg: '#201648',
            modalTile: '#201648',

            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '50px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '0px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#201648',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#a1001a',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#E8F1ED',
        },
        implement_delivery_method: true,
    },
    HD: {
        id: '1019',
        code: 'HD',
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        bloomreach: {
            account_id: '5027',
            domain_key: '1800flowers_com',
            request_id: '4548275533545',
            url: 'harryanddavid_com',
            view_id: 'Harry & David Brand',
        },
        domain: 'harryanddavid', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 21051, // brand's unique store ID
        catalogId: 16802, // brands have many catalogs,but web has one unique catalog
        description: 'Harry & David', // simple description of brand used for alt text
        other: {
            order_service_email: 'service@harryanddavid.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'Arial', 'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Roboto',
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        presentation_family: 'food',

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                // 500: '#979797',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#a3ce99',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#2f2f2f',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '51px',
            navSecondaryHeight: '30px',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',
            colorPrimaryAccount: '#a1001a',  // Used by css baseline to set GL account primary
            colorSecondaryAccount: '#790000',  // Used by css baseline to set GL account secondary
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#1f1f1b', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            buttonBackgroundColor: '#a1001a',
            buttonBackgroundColorSecondary: '#bd4d5f',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#f4f2f7',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
                minWidth: '768px',
                width: '100%',
            },
            deliverySentence: '#52287e',
            productAvailibilityPDP: '#a1001a',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            select: '#646464',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
                // For now we are pulling these colors from content stack
                // skus: { // only for HD use
                //     availableToShipTextColor: '#999999',
                //     skuBorderColor: '#c6b66f',
                //     priceDiscountColor: '#506985',
                //     checkedRadioColor: '#ff9900',
                //     uncheckedRadioColor: '#f5f8fa',
                //     radioHoverColor: '#ebf1f5',
                //     skuLabelAmountColor: '#7C7C7C',
                // },
            },
            rewardColor: '#00488a',
            primaryButton: '#a1001a',
            successButton: '#a1001a',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#F4F2F7',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '0 auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '99%',
                    height: 'auto',
                },
                Medium: {
                    width: '100%',
                    maxWidth: '340px',
                    height: '100%',
                    minHeight: '1px',
                },
                Small: {
                    width: '100%',
                },
                Large: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#FF0000',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#525252',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#2f2f2f',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',

            upsellsBackground: '#e8f1ec',
            upsellsTextColor: '#2F2F2F',
            upsellsFutureAvailabilityColor: '#A2011A',
            upsellsHeaderFonts: 'Crimson Text',
            filterDropdownHoverColor: '#E8F1ED',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/h/view/about01',
        ],
        implement_delivery_method: false,
    },
    '18B': {
        id: '1009',
        code: '18B',
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        domain: '1800baskets',
        storeId: 20054,
        catalogId: 13802,
        description: '1-800-Baskets',
        other: {
            order_service_email: '',
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        presentation_family: 'flower',
        palette: {
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            common: {
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#a1001a',
            },
            navHeight: '53px',
            product: {
                name: '#1f1f1b',
                retailPrice: '#1f1f1b',
                crossedRetailPrice: '#1f1f1b',
                salePrice: '#a1001a',
            },
            // replacement keys for clarity and versatility
            colorPrimary: '#9c0352', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',

            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#a1001a',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',

            // existing acceptable values
            black: '#1f1f1b',
            white: '#fff',
            bgFooter: '#42434b',
            bgHeader: '#FFFFFF',
            bgPhoneIcon: '#1bc86d',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#9c0352',
            colorIconHeader: '#000',
            productAvailibilityPDP: '#a1001a',
            disableButton: '#d8d8d8',
            error: { main: '#ff0000', guidedNav: '#f71449' },
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#9c0352',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#ce046b',
            orderConfirmationHeader: '#9c0352',
            orderConfirmationText: 'black',
            primary: { 500: '#9c0352' },
            rewardColor: '#00488a',
            primaryButton: '#1bc86d',
            successButton: '#1bc86d',
            productTitleColor: '#1f1f1b',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#324765',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            buttonBackgroundColor: '#f50057',
            buttonBackgroundColorSecondary: '#F73379',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            shape: {
                borderRadius: '4px',
            },
            snipeText: 'white',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(206,4,107,0.7)',
            snipeTextFontSize: 12,
            snipeTextFontWeight: 300,
            guidedNav: {
                background: '#FFF',
            },
            tickCheck: '#00CC33',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            mobileMenuColor: '#000',
            desktopHeaderMenu: {
                // TODO: replace this with brand's real values
                background: '#f4f2f7',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#8E1429',
            checkRadioBtn: '#8E1429',
            copyright: '#000',
            mobileFooterBottomLink: '#000',
            desktopBgFooter: '#ececec',
            modalBg: '#ececec',
            modalTile: '#5b322c',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // OK to modify values as long as replacement is updated as well (unless specifically noted)
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // this is weirdly named >> MenuItem.js class = toggleHeader
            cta1: '#9c0352', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fafafa',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '100%',
                        upLarge: '95%',
                    },
                },
            },
            faqBgColor: '#ffeffb',
            availableMessageColor: '#666',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            contentColor: '#666666',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#a1001a',
            crDividerColor: '#cecece',
            nup: {
                margin: '30px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    fontWeight: '400',
                    fontSize: '26px',
                    letterSpacing: '.4px',
                },
                Standard: {
                    width: '200px',
                    height: 'auto',
                },
                Medium: {
                    width: '300px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: 'auto auto 25px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: 'auto',
                textAlign: 'center',
            },
            checkoutHeaderBg: '#ffffff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#E8F1ED',
        },
        typography: {
            useNextVariants: true,
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: 14,
        },
        excludeSEO: [
            'About-Us-Privacy-Policy',
            'About-Us-Terms-of-Use',
            'passport-baskets',
            'themarketboxlandingpage',
        ],
        implement_delivery_method: false,
    },
    CCO: {
        id: '1012',
        code: 'CCO',
        giftMessageConfig: {
            giftMessageMaxLines: 4,
            giftMessageMaxChars: 30,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        domain: 'cheryls', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 10202, // brand's unique store ID
        catalogId: 11102, // brands have many catalogs,but web has one unique catalog
        description: 'Cheryl\'s Cookies', // simple description of brand used for alt text
        other: {
            order_service_email: 'customerservice@cheryls.com',
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            pdpSkuLabel: {
                fontSize: '0.938em',
            },
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},

        presentation_family: 'food',

        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                // 500: '#979797',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#2f2f2f',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '30px',
            colorPrimaryAccount: '#522d23',  // Used by css baseline to set GL account primary
            colorSecondaryAccount: '#790000',  // Used by css baseline to set GL account secondary
            buttonBackgroundColor: '#a1001a',
            buttonBackgroundColorSecondary: '#bd4d5f',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#522d23', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',

            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#a1001a',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#42434b',
            bgHeader: '#fff',
            bgPhoneIcon: '#1bc86d',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#43201c',
            bgTile2: '#2f2f2f',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#5b322c',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#efefef',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',

            productAvailibilityPDP: '#a1001a',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#3a0704',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
                skus: { // only for HD use
                    availableToShipTextColor: '#999999',
                    skuBorderColor: '#c6b66f',
                    priceDiscountColor: '#506985',
                    checkedRadioColor: '#ff9900',
                    uncheckedRadioColor: '#f5f8fa',
                    radioHoverColor: '#ebf1f5',
                    skuLabelAmountColor: '#7C7C7C',
                },
            },
            rewardColor: '#00488a',
            primaryButton: '#e80a4d',
            successButton: '#185357',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileMenuColor: '#000',
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#fcf8f0',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',

            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '0 auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
                Large: {
                    width: '100%',
                    height: 'auto',
                },
            },
            genericBanner: {
                margin: 'auto auto 20px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            checkoutHeaderBg: '#522d23',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: 'rgba(200, 233, 241, 0.31)',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/h/view/about01',
        ],
        implement_delivery_method: false,
    },
    TPF: {
        id: '1002',
        code: 'TPF',
        giftMessageConfig: {
            giftMessageMaxLines: 4,
            giftMessageMaxChars: 30,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        domain: 'thepopcornfactory', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 10201, // brand's unique store ID
        catalogId: 10101, // brands have many catalogs,but web has one unique catalog
        description: 'The Popcorn Factory', // simple description of brand used for alt text
        presentation_family: 'food',
        other: {
            order_service_email: 'customerservice@thepopcornfactory.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'lato',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Trebuchet MS',
                'Arial',
                'Helvetica',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#b01116',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#b01116',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#000000',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#1f1f1b', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#444', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            buttonBackgroundColor: '#b01116',
            buttonBackgroundColorSecondary: '#bf4044',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            productAvailibilityPDP: '#a1001a',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#b01116',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
                // For now we are pulling these colors from content stack
                // skus: { // only for HD use
                //     availableToShipTextColor: '#999999',
                //     skuBorderColor: '#c6b66f',
                //     priceDiscountColor: '#506985',
                //     checkedRadioColor: '#ff9900',
                //     uncheckedRadioColor: '#f5f8fa',
                //     radioHoverColor: '#ebf1f5',
                //     skuLabelAmountColor: '#7C7C7C',
                // },
            },
            rewardColor: '#00488a',
            primaryButton: '#b01116',
            successButton: '#058942',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#ffffff',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#b01116',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '0 auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '20px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '0px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            homePageTextColor: '#5b322c',
            productPriceColor: '#666',
            footermainHeading: '#000099',
            checkoutHeaderBg: '#b13716',
            secureCheckoutLogo: '',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#EBEBEB',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/h/view/about01',
        ],
        implement_delivery_method: false,
    },
    SCH: {
        id: '1025',
        code: 'SCH',
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        domain: 'simplychocolate', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 24052, // brand's unique store ID
        catalogId: 20803, // brands have many catalogs,but web has one unique catalog
        description: 'simply Chocolate', // simple description of brand used for alt text
        other: {
            order_service_email: '',
        },
        typography: {
            fontFamily: [
                'GothamBook',
                'Arial',
                'Helvetica',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},

        presentation_family: 'flower',

        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#512C1C',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                // 500: '#979797',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#512C1C',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#512C1C',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#512c1c',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '30px',
            buttonBackgroundColor: '#512C1C',
            buttonBackgroundColorSecondary: '#735649',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#512c1d', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',

            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#a1001a',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#42434b',
            bgHeader: '#fff',
            bgPhoneIcon: '#1bc86d',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#43201c',
            bgTile2: '#2f2f2f',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#5b322c',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#efefef',
                text: '#333',
                border: 'none',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#A1662C',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
                skus: { // only for HD use
                    availableToShipTextColor: '#999999',
                    skuBorderColor: '#c6b66f',
                    priceDiscountColor: '#506985',
                    checkedRadioColor: '#ff9900',
                    uncheckedRadioColor: '#f5f8fa',
                    radioHoverColor: '#ebf1f5',
                    skuLabelAmountColor: '#7C7C7C',
                },
            },
            rewardColor: '#00488a',
            primaryButton: '#A1662C',
            successButton: '#A1662C',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileMenuColor: '#000',
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#512c1d',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#a1001a',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '100%',
                        upLarge: '1400px',
                    },
                },
            },
            nup: {
                margin: '30px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
                Large: {
                    width: '100%',
                    height: 'auto',
                },
            },
            genericBanner: {
                margin: 'auto auto 20px auto',
            },
            heroSingle: {
                margin: '0px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            // Sympathy Helpful Resource
            availableMessageColor: '#666',
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            checkoutHeaderBg: '#ffffff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#E8F1ED',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/h/view/about01',
        ],
        implement_delivery_method: false,
    },
    SY: {
        id: '1018',
        code: 'SY',
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: false,
            signatureMaxChars: 18,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        domain: 'stockyards', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 22051, // brand's unique store ID
        catalogId: 17802, // brands have many catalogs,but web has one unique catalog
        description: 'Stock Yards', // simple description of brand used for alt text
        other: {
            order_service_email: 'myorder@stockyards.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'lato',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Roboto',
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        presentation_family: 'food',

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                // 500: '#979797',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#2f2f2f',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '51px',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#3c3c35', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#3c3c35', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',

            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#a1001a',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',

            // existing acceptable values
            black: '#1f1f1b',
            white: '#fff',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#5b322c',
            colorIconHeader: '#000',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#000',
            orderConfirmationHeader: '#5b322c',
            orderConfirmationText: '#5b322c',
            rewardColor: '#00488a',
            primaryButton: '#a1001a',
            productTitleColor: '#3c3c35',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#1f1f1b',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            buttonBackgroundColor: '#333',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#3f3c3c',
                main: '#fff',
                product: '#fff',
                alternate: '#3f3c3c',
                nonProduct: '#3f3c3c', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#3f3c3c',
            },
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#f4f2f7',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#1f1f1b',
            mobileFooterBottomLink: '#1f1f1b',
            desktopBgFooter: '#f2f2f2',
            modalBg: '#f2f2f2',
            modalTile: '#1f1f1b',
            salePrice: '#7c2529',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // OK to modify values as long as replacement is updated as well (unless specifically noted)
            cta1: '#3c3c35', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },

            nup: {
                margin: '0 auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '99%',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#231f20',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#EFF3F3',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/s/view/about01',
        ],
        implement_delivery_method: false,
    },
    WLF: {
        id: '1020',
        code: 'WLF',
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: true,
            signatureMaxChars: 18,
        },
        bloomreach: {
            account_id: '5027',
            domain_key: '1800flowers_com',
            request_id: '4548275533545',
            url: 'wolfermans_com',
            view_id: 'Wolferman\'s Brand',
        },
        domain: 'wolfermans', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 21551, // brand's unique store ID
        catalogId: 17302, // brands have many catalogs,but web has one unique catalog
        description: 'Wolferman', // simple description of brand used for alt text
        other: {
            order_service_email: 'service@wolfermans.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'assistantregular',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'loraitalic',
                'Verdana',
                'Arial',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        presentation_family: 'food',

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#5c5757',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                // 500: '#979797',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#1f1f1b',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '51px',
            buttonBackgroundColor: '#a1001a',
            buttonBackgroundColorSecondary: '#bd4d5f',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#5c5757', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#f4f2f7',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            productAvailibilityPDP: '#a1001a',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            select: '#4b5d6e',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#4b5d6e',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
                // For now we are pulling these colors from content stack
                // skus: { // only for HD use
                //     availableToShipTextColor: '#999999',
                //     skuBorderColor: '#c6b66f',
                //     priceDiscountColor: '#506985',
                //     checkedRadioColor: '#ff9900',
                //     uncheckedRadioColor: '#f5f8fa',
                //     radioHoverColor: '#ebf1f5',
                //     skuLabelAmountColor: '#7C7C7C',
                // },
            },
            rewardColor: '#00488a',
            primaryButton: '#a1001a',
            successButton: '#a1001a',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#a1001a',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#f2f2f2',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            salePrice: '#b71f2e',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '0 auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '99%',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#FF0000',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#525252',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#5c5757',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        excludeSEO: [
            '/gifthistory-home-gift-baskets',
            '/About-Us-Privacy-Policy',
            '/h/view/about01',
        ],
        implement_delivery_method: false,
    },
    FB: {
        id: '1010',
        code: 'FB',
        domain: 'fruitbouquets',
        storeId: 20551,
        catalogId: 16302,
        description: 'Fruit Bouquets',
        other: {
            order_service_email: '',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        typography: {
            fontFamily: [
                'Roboto',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},

        presentation_family: 'flower',

        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#5f3c86',
                900: '#6f5092',
                800: '#7f639e',
                700: '#8f77aa',
                600: '#9f8ab6',
                500: '#af9ec3',
                400: '#bfb1cf',
                300: '#cfc5db',
                200: '#dfd8e7',
                100: '#efecf3',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#00C876',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#a3ce99',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#00C876',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',
            buttonBackgroundColor: '#00C876',
            buttonBackgroundColorSecondary: '#33d391',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#7340a0', // replaces cta1
            colorPrimaryContrast: '#fff', // DOES NOT PASS WCAG AA/AAA (with #FFF contrast,only fails WCAG AAA with #000),
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorAlert: '#f71548',
            contentColor: '#666666',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',

            black: '#1f1f1b',
            white: '#fff',
            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: '#201648',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            OBHeadingColor: '#663399',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            select: '#646464',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#1bc86d',
            successButton: '#1bc86d',
            submit: '#33333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productTitleColor: '#1f1f1b',
            productAvailibilityPDP: '#a1001a',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            mobileMenuColor: '#fff',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#65388b',
            checkRadioBtn: '#65388b',
            copyright: '#606060',
            mobileFooterBottomLink: '#65388b',
            desktopBgFooter: '#ededeb',
            modalBg: '#65388b',
            modalTile: '#65388b',

            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '50px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#65388b',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#000',
            salePriceColor: '#a1001a',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        implement_delivery_method: true,
    },
    BRY: {
        id: '1029',
        code: 'BRY',
        domain: 'berries',
        storeId: 25052,
        catalogId: 22303,
        description: 'Sharis Berries',
        presentation_family: 'flower',
        other: {
            order_service_email: '',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        breakpoints: {},
        overrides: {},
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#223970',
                900: '#6f5092',
                800: '#7f639e',
                700: '#8f77aa',
                600: '#9f8ab6',
                500: '#af9ec3',
                400: '#bfb1cf',
                300: '#cfc5db',
                200: '#dfd8e7',
                100: '#efecf3',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#00C876',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#a3ce99',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#00C876',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',

            // replacement keys for clarity and versatility
            colorPrimary: '#D03E38', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            // existing acceptable values
            black: '#1f1f1b',
            white: '#fff',
            bgFooter: '#f2f2f2',
            bgHeader: '#000000',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#1bc86d',
            successButton: '#1bc86d',
            productTitleColor: '#1f1f1b',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#65388b',
            checkRadioBtn: '#65388b',
            copyright: '#606060',
            mobileFooterBottomLink: '#65388b',
            desktopBgFooter: '#65388b',
            modalBg: '#65388b',
            modalTile: '#65388b',
            salePrice: '#b6002f',
            buttonBackgroundColor: '#00C876',
            buttonBackgroundColorSecondary: '#33d391',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // OK to modify values as long as replacement is updated as well (unless specifically noted)
            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED
            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },

            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorInfo: '#1976d2',
            clubsTypebackground: '#F2F0EC',
            contentColor: '#666666',
            colorValid: '#24b200',

            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            OBHeadingColor: '#663399',
            select: '#646464',
            submit: '#33333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productAvailibilityPDP: '#a1001a',
            mobileMenuColor: '#fff',
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '0 auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#65388b',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 15,
        },
    },
    TMP: {
        id: '1027',
        code: 'TMP',
        domain: 'goodsey',
        storeId: 24552,
        catalogId: 21303,
        description: 'TheMarket',
        presentation_family: 'flower',
        other: {
            order_service_email: '',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 3,
            giftMessageMaxChars: 30,
            excludeFromTextLabel: true,
            signatureMaxChars: 24,
        },
        breakpoints: {},
        overrides: {},
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#201648',
                900: '#6f5092',
                800: '#7f639e',
                700: '#8f77aa',
                600: '#9f8ab6',
                500: '#af9ec3',
                400: '#bfb1cf',
                300: '#cfc5db',
                200: '#dfd8e7',
                100: '#efecf3',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#185357',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#a3ce99',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#185357',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',

            // replacement keys for clarity and versatility
            colorPrimary: '#D03E38', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            // existing acceptable values
            black: '#1f1f1b',
            white: '#fff',
            bgFooter: '#f2f2f2',
            bgHeader: '#000000',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#185357',
            successButton: '#185357',
            productTitleColor: '#1f1f1b',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#201648',
            modalBg: '#201648',
            modalTile: '#201648',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // OK to modify values as long as replacement is updated as well (unless specifically noted)
            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED
            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },

            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorInfo: '#1976d2',
            clubsTypebackground: '#F2F0EC',
            contentColor: '#666666',
            colorValid: '#24b200',

            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            buttonBackgroundColor: '#333',
            OBHeadingColor: '#663399',
            select: '#646464',
            submit: '#33333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productAvailibilityPDP: '#a1001a',
            mobileMenuColor: '#fff',
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#201648',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 15,
        },
    },
    HLN: {
        id: '1026',
        code: 'HLN',
        domain: 'goodsey',
        storeId: 20053,
        catalogId: 18302,
        description: 'TheMarket',
        presentation_family: 'flower',
        other: {
            order_service_email: '',
        },
        breakpoints: {},
        overrides: {},
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#201648',
                900: '#6f5092',
                800: '#7f639e',
                700: '#8f77aa',
                600: '#9f8ab6',
                500: '#af9ec3',
                400: '#bfb1cf',
                300: '#cfc5db',
                200: '#dfd8e7',
                100: '#efecf3',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#185357',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#a3ce99',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#185357',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',

            // replacement keys for clarity and versatility
            colorPrimary: '#D03E38', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            // existing acceptable values
            black: '#1f1f1b',
            white: '#fff',
            bgFooter: '#f2f2f2',
            bgHeader: '#000000',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#185357',
            successButton: '#185357',
            productTitleColor: '#1f1f1b',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#201648',
            modalBg: '#201648',
            modalTile: '#201648',
            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // OK to modify values as long as replacement is updated as well (unless specifically noted)
            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED
            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },

            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorInfo: '#1976d2',
            clubsTypebackground: '#F2F0EC',
            contentColor: '#666666',
            colorValid: '#24b200',

            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            buttonBackgroundColor: '#333',
            OBHeadingColor: '#663399',
            select: '#646464',
            submit: '#33333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productAvailibilityPDP: '#a1001a',
            mobileMenuColor: '#fff',
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#201648',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 15,
        },
    },
    PMA: {
        id: '1030',
        code: 'PMA',
        domain: 'flowers', // temporal while CMS create the PMALL
        storeId: 20051, // brand's unique store ID
        catalogId: 13302,
        description: 'Personalization Mall',
        presentation_family: 'flower',
        other: {
            order_service_email: '',
        },
    },
    PML: {
        id: '1030',
        code: 'PML',
        fsOrgId: null,
        domain: 'personalizationmall',
        storeId: null,
        catalogId: null,
        description: 'Personalization Mall',
        presentation_family: 'personalization', // it will be control by CS
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: true,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        other: {
            order_service_email: 'customerservice@personalizationmall.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#000000',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#ae201f', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#444', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            buttonBackgroundColor: '#ae201f',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            productAvailibilityPDP: '#ae201f',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#b01116',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            rewardColor: '#00488a',
            primaryButton: '#ae201f',
            successButton: '#185357',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#ae201f',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#ae201f',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#ffffff',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '20px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '20px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '0px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            homePageTextColor: '#5b322c',
            productPriceColor: '#666',
            footermainHeading: '#000099',
            checkoutHeaderBg: '#ffffff',
            secureCheckoutLogo: '',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        excludeSEO: [],
        implement_delivery_method: false,
    },
    VC: {
        id: '1031',
        code: 'VC',
        fsOrgId: null,
        domain: 'vitalchoice',
        storeId: 22051,
        catalogId: 17802,
        description: 'Vital Choice',
        presentation_family: 'food', // it will be control by CS
        giftMessageConfig: {
            giftMessageMaxLines: 4,
            giftMessageMaxChars: 29,
            excludeFromTextLabel: true,
            signatureMaxChars: 18,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        other: {
            order_service_email: 'customercare@vitalchoice.com',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#cf3d02',
                900: '#e14b0f',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#cf3d02',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#000000',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            buttonBackgroundColor: '#cf3d02',
            buttonBackgroundColorSecondary: '#d86334',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#cf3d02', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#444', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#ae201f',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#ae201f',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            productAvailibilityPDP: '#cf3d02',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#b01116',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#ae201f',
                    goButtonColor: '#fff',
                },
            },
            rewardColor: '#00488a',
            primaryButton: '#cf3d02',
            successButton: '#185357',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#cf3d02',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#cf3d02',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#ffffff',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '20px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '20px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '0px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#f15a29',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            homePageTextColor: '#5b322c',
            productPriceColor: '#666',
            footermainHeading: '#000099',
            checkoutHeaderBg: '#ffffff',
            secureCheckoutLogo: '',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        excludeSEO: [],
        implement_delivery_method: false,
    },
    TR: {
        id: '1033',
        code: 'TR',
        fsOrgId: null,
        domain: 'thingsremembered',
        storeId: null,
        catalogId: null,
        description: 'Things Remembered',
        presentation_family: 'personalization', // it will be control by CS
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: true,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        other: {
            order_service_email: '',
        },
        typography: {
            // Its a default font family that can used throughout the app
            fontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
            secondaryFontFamily: [
                'Helvetica',
                'sans-serif',
            ].join(','),
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},

        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#2f2f2f',
                900: '#444444',
                800: '#595959',
                700: '#6d6d6d',
                600: '#828282',
                500: '#595959',
                400: '#acacac',
                300: '#c1c1c1',
                200: '#d5d5d5',
                100: '#ededed',
                contrastText: '#ffffff', // Made to default contrast color over
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#a1001a',
                900: '#aa1a31',
                800: '#b43348',
                700: '#bd4d5f',
                600: '#c76676',
                500: '#do808d',
                400: '#d999a3',
                300: '#e3b3ba',
                200: '#ecccd1',
                100: '#f6e6e8',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#a1001a',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: '#000000',
                secondary: '#757575',
                disabled: '#B7B7B7',
                hint: '#000000',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#ae201f', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#444', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#eee',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            colorAlert: '#f71548',
            colorAlertContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            cardPagebackground: '#ebeadd',
            colorSuccess: '#058942',
            contentHeading: '#6e9930',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            borderLeft: '#52287e',
            black: '#1f1f1b',
            white: '#fff',

            backgroundColor: '#f9f6f6',
            buttonBackgroundColor: '#ae201f',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: 'white',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#2f2f2f',
            bigBoldLabel: '#595959',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            colorHeadingSympathy: '#70548f',
            colorIconHeader: '#000',
            productAvailibilityPDP: '#ae201f',
            desktopHeaderMenu: {  // TODO: replace this with brand's real values
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            OBHeadingColor: '#663399',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: 'black',
            globalBannerTextColor: 'white',
            globalBannerTextDecoration: 'none',
            linkMenu: '#595959',
            orderConfirmationHeader: '#595959',
            orderConfirmationText: 'black',
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#b01116',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            rewardColor: '#00488a',
            primaryButton: '#ae201f',
            successButton: '#185357',
            productTitleColor: '#2f2f2f',
            sectionHeaderTextColor: '#202020',
            secondaryButton: '#595959',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#3c3c35',
            snipeTextPromo: '#ae201f',
            snipeTextBackground: 'rgba(255,255,255,0.82)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            submit: '#333333',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#595959',
            checkRadioBtn: '#ae201f',
            copyright: '#747472',
            mobileMenuColor: '#000',
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#909090',
            },
            mobileFooterBottomLink: '#747472',
            desktopBgFooter: '#ffffff',
            modalBg: '#f2f2f2',
            modalTile: '#f2f2f2',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            salePrice: '#a1001a',

            cta1: '#2f2f2f', // DEPRECATED
            cta2: '#a94', // DEPRECATED
            cta3: '#3c3c35', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#5b322c', // DEPRECATED
            brown2: '#311714', // DEPRECATED
            brown3: '#600600', // DEPRECATED
            brown4: '#d9d0c1', // DEPRECATED
            brown5: 'rgba(255,255,255,0.82)', // DEPRECATED
            brown6: '#ded8d8', // DEPRECATED
            grey1: '#2f2f2f', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#909090', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#e3e3e3', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#595959', // DEPRECATED
            grey11: '#e4e4e4', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#7c7c7d',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#7c7c7d',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '20px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '20px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '100%',
                },
            },
            genericBanner: {
                margin: '0px auto',
            },
            heroSingle: {
                margin: '15px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            contentColor: '#666666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            // celebrations Rewards
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',

            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            homePageTextColor: '#5b322c',
            productPriceColor: '#666',
            footermainHeading: '#000099',
            checkoutHeaderBg: '#ffffff',
            secureCheckoutLogo: '',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F5F5F5',
        },
        excludeSEO: [],
        implement_delivery_method: false,
    },
    FL: {
        id: '1034',
        code: 'FL',
        domain: 'florists', // brand's web domain - string in the middle of  https://www.1800flowers.com
        storeId: 20051, // brand's unique store ID
        catalogId: 13302, // brands have many catalogs,but web has one unique catalog
        description: '1-800-Flowers', // simple description of brand used for alt text
        other: {
            order_service_email: '',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'Verdana',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},
        blockHeading: {},
        overrides: {},

        presentation_family: 'flower',

        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#0e4728',
                900: '#0e4728',
                800: '#1a6340',
                700: '#22724d',
                600: '#28825a',
                500: '#2c8f65',
                400: '#3f9f78',
                300: '#5bb08d',
                200: '#86c7ac',
                100: '#e8f7f0',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#f8eee5',
                900: '#583c2f',
                800: '#684a3a',
                700: '#765743',
                600: '#87644d',
                500: '#946f55',
                400: '#a6856f',
                300: '#b89c89',
                200: '#cfb9aa',
                100: '#e5d4c9',
                contrastText: '#000',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                main: '#0e4728',
                black: '#000',
                white: '#fff',
                grey: '#757575',
                lightGrey: '#D9D9D9',
                green: '#6E9930',
                red: '#d90059',
                blue: '#371A6E',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            buttonBackgroundColor: '#0e4728',
            buttonBackgroundColorSecondary: '#22724d',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: '#0e4728', // replaces cta1
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#e8eaec',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorAlert: '#f71548',
            contentColor: '#666666',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',

            black: '#1f1f1b',
            white: '#fff',
            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: '#201648',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bgContrastPrimaryColor: '#EBEBEB',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            OBHeadingColor: '#663399',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            select: '#646464',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#0e4728',
            successButton: '#0e4728',
            submit: '#333333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productTitleColor: '#1f1f1b',
            productAvailibilityPDP: '#a1001a',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            bgChatMessage: '#0e4728',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            mobileMenuColor: '#fff',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#201648',
            modalBg: '#201648',
            modalTile: '#201648',

            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#5E5E5E',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#585858',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '50px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '0px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#f8eee5',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#a1101a',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#F4F2F7',
            noProductsTextColor: '#EC0909',
            footerLinkImgBg: '#E8F1ED',
            slideOutMiniCartFont: 'LatoMedium,sans-serif',
            ctaBgColorNup4: '#bca1c6',
            ctaColorNup4: '#ffffff',
            ctaBorderClrNup4: '#bca1c6',
        },
        implement_delivery_method: true,
    },
    CI: {
        id: '1036',
        code: 'CI',
        domain: 'cardisle',
        storeId: 20051,
        catalogId: 13302,
        description: 'Card Isle',  // TODO: ask for this
        presentation_family: 'flower',
        other: {
            order_service_email: 'customerservice@cardisle.com',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'Verdana',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],        // eslint-disable-line arrow-parens
        breakpoints: {},
        blockHeading: {},
        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: 'rgb(0 96 230)',
                900: 'rgb(230 243 255)',
                800: '#7f639e',
                700: '#8f77aa',
                600: '#9f8ab6',
                500: '#af9ec3',
                400: '#bfb1cf',
                300: '#cfc5db',
                200: '#dfd8e7',
                100: '#efecf3',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: 'rgb(0 96 230)',
                900: '#00344F',
                800: '#00355F',
                700: '#00366F',
                600: '#00377F',
                500: '#00388E',
                400: '#00399F',
                300: '#003AAE',
                200: '#003BBE',
                100: '#003FFE',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                black: '#000',
                white: '#fff',
                grey: '#848181',
                green: '#6E9930',
                red: '#d90059',
                blue: '#371A6E',
            },
            background: {
                paper: '#fff',
                default: '#fff', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            colorPrimaryAccountCtaButton: 'rgb(0 96 230)',
            colorPrimaryAccountCtaButtonOnHover: 'rgb(70 147 255)',
            iconColor: '#368F35',
            thankyoucards: {
                separator: '#c4c4c4',
                underlineColor: '#673689',
                primaryColor: '#201648',
                bgColor: '#f3E6f4',
                footerBgColor: '#201648',
                typography: 'lato, sans-serif',
                titleTypography: 'Playfair Display',
            },

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            // All options below this line is officially deprecated
            // Notes: We shouldn't be writing component/feat specific css at a brand config level.

            colorPrimary: 'rgb(0 96 230)',
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600', // replaces cta2
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b', // replaces cta3
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b', // replaces cta4
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b', // added for flexibility
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b', // replaces gray*
            colorNeutral10: '#fafafa', // begin alpha variants
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#e8eaec',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b', // end alpha variants

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorAlert: '#f71548',
            contentColor: '#666666',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',

            black: '#1f1f1b',
            white: '#fff',
            borderLeft: '#52287e',
            backgroundColor: '#f9f6f6',
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#f2f2f2',
            bgHeader: '#fff',
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bgContrastPrimaryColor: '#EBEBEB',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            buttonBackgroundColor: '#333',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            OBHeadingColor: '#663399',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            select: '#646464',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: 'rgb(0 96 230)',
            successButton: 'rgb(0 96 230)',
            submit: '#333333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productTitleColor: '#1f1f1b',
            productAvailibilityPDP: '#a1001a',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#324765',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#fff',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090', // DEPRECATED- replaced by 'alternate'
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#fff',
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            mobileMenuColor: '#fff',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#201648',
            modalBg: '#201648',
            modalTile: '#201648',

            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#696A69',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#767775',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '50px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '0px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#201648',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#2e8540',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#E8F1ED',
        },
        implement_delivery_method: true,
    },
    CSG: {
        id: '1038',
        code: 'CSG',
        domain: 'celebrations',
        storeId: 20051,
        catalogId: 13302,
        description: 'Celebrations',
        presentation_family: 'flower',
        other: {
            order_service_email: 'customerservice@celebrations.com',
        },
        giftMessageConfig: {
            giftMessageMaxLines: 1,
            giftMessageMaxChars: 180,
            excludeFromTextLabel: false,
            signatureMaxChars: 14,
        },
        bloomreach: {
            account_id: null,
            domain_key: null,
            request_id: null,
            url: null,
            view_id: null,
        },
        typography: {
            fontFamily: [
                'Helvetica',
                'Arial',
                'Verdana',
                'sans-serif',
            ].join(','),
            useNextVariants: true,
            fontSize: 16,
        },
        spacing: (factor) => [0, 4, 8, 16, 32, 64][factor],
        breakpoints: {},
        blockHeading: {},
        overrides: {},
        palette: {
            // Brand Primary colors in 10% shades — dark to light
            primary: {
                main: '#37211F',  // Primary button color
                900: '#4d1c19',
                800: '#623633',
                700: '#77504c',
                600: '#8c6a66',
                500: '#a18480',
                400: '#b69e99',
                300: '#cbb8b3',
                200: '#EEE9DD',
                100: '#f5ece6',
                contrastText: '#fff',
            },
            // Brand Secondary colors in 10% shades — dark to light
            secondary: {
                main: '#37211F',
                900: '#4d1c19',
                800: '#623633',
                700: '#77504c',
                600: '#8c6a66',
                500: '#a18480',
                400: '#b69e99',
                300: '#cbb8b3',
                200: '#e0d2cc',
                100: '#f5ece6',
                contrastText: '#fff',
            },

            tertiary: {},
            quadrinary: {},

            status: {
                main: '#E1B336',
                500: '#E1B336',
                contrastText: '#fff',
            },
            error: {
                main: '#ff0000',
                500: '#ff0000',
                contrastText: '#fff',
                guidedNav: '#f71449',
            },
            success: {
                main: '#058942',
                900: '#5c9c4d',
                800: '#528a44',
                700: '#47793b',
                600: '#3d6833',
                500: '#66ad55',
                400: '#75b566',
                300: '#85bd77',
                200: '#94c688',
                100: '#d9f5dc',
                contrastText: '#fff',
            },
            common: {
                black: '#000',
                white: '#fff',
                grey: '#848181',
                green: '#6E9930',
                red: '#d90059',
                blue: '#371A6E',
                lightGrey: '#D9D9D9',
            },
            background: {
                paper: '#FFFDF4', // Light cream background
                default: '#FFFDF4', // Used by css baseline to set body bg color
            },
            text: {
                primary: 'rgba(0, 0, 0, 0.87)',
                secondary: 'rgba(0, 0, 0, 0.54)',
                disabled: 'rgba(0, 0, 0, 0.38)',
                hint: 'rgba(0, 0, 0, 0.38)',
            },
            contrastThreshold: 3,
            tonalOffset: 0.2,
            navHeight: '52px',
            celebrationsColor: '#7ac3a6',
            passportColor: '#2d7dba',
            unSelectedDeliveryDay: '#37211F',
            selectedDeliveryDay: '#E9EFF0',
            chargesDeliveryDay: '#236FCD',
            disabledDeliveryDay: '#7B6D6B',
            colorPrimaryAccountCtaButton: '#37211F',
            colorPrimaryAccountCtaButtonOnHover: '#5a3a37',
            iconColor: '#368F35',
            thankyoucards: {
                separator: '#c4c4c4',
                underlineColor: '#673689',
                primaryColor: '#201648',
                bgColor: '#f3E6f4',
                footerBgColor: '#201648',
                typography: 'lato, sans-serif',
                titleTypography: 'Playfair Display',
            },
            buttonBackgroundColor: '#37211F',
            buttonBackgroundColorSecondary: '#5f4d4b',

            // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
            colorPrimary: '#37211F',
            colorPrimaryContrast: '#fff',
            colorSecondary: '#600',
            colorSecondaryContrast: '#fff',
            colorTertiary: '#1f1f1b',
            colorTertiaryContrast: '#fff',
            colorQuaternary: '#1f1f1b',
            colorQuaternaryContrast: '#fff',
            colorQuinary: '#1f1f1b',
            colorQuinaryContrast: '#fff',
            colorIcBanner10: '#e94e75',
            colorIcBanner20: '#7ca60b',
            colorNeutral: '#1f1f1b',
            colorNeutral10: '#fafafa',
            colorNeutral20: '#f5f5f5',
            colorNeutral30: '#e8eaec',
            colorNeutral40: '#e0e0e0',
            colorNeutral50: '#bdbdbd',
            colorNeutral60: '#9e9e9e',
            colorNeutral70: '#757575',
            colorNeutral80: '#373737',
            colorNeutral90: '#1b1b1b',

            colorInfo: '#1976d2',
            colorInfoContrast: '#fff',
            colorWarning: '#ffa000',
            colorWarningContrast: '#fff',
            clubsTypebackground: '#F2F0EC',
            colorAlert: '#f71548',
            contentColor: '#666666',
            colorAlertContrast: '#fff',
            colorSuccess: '#058942',
            colorSuccessContrast: '#fff',
            colorDisabled: '#ccc',
            colorDisabledContrast: '#1f1f1b',
            colorValid: '#24b200',

            black: '#1f1f1b',
            white: '#fff',
            borderLeft: '#52287e',
            backgroundColor: '#FFFDF4', // Light cream background
            borderBottom: '1px dotted #7e7e7e',
            bgFooter: '#FFFDF4', // Light cream footer
            bgHeader: '#FFFDF4', // Light cream header
            bgPhoneIcon: '#a1001a',
            bgPopup: 'rgba(0,0,0,.85)',
            bgSelected: 'rgba(48,69,98,.1)',
            bgTile1: '#a1001a',
            bgTile2: '#304562',
            bgTextOverlay1: 'rgba(0,0,0,0.6)',
            bgContrastPrimaryColor: '#EBEBEB',
            bigBoldLabel: '#1f1f1b',
            colorIconHeader: '#000',
            contentHeading: '#6e9930',
            cardPagebackground: '#ebeadd',
            colorHeadingSympathy: '#70548f',
            deliverySentence: '#52287e',
            disableButton: '#d8d8d8',
            gfBgColor: '#9872bb',
            OBHeadingColor: '#663399',
            gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
            gfMobileLabelTextColor: '#212121',
            gfMobileSelectOptionTextColor: '#606060',
            gfMobileZipInputLabelTextColor: '#a0a0a0',
            gfTabDesktopInputBorder: '1px solid #333',
            globalBannerBackgroundColor: '#1f1f1b',
            globalBannerTextColor: 'white',
            select: '#646464',
            globalBannerTextDecoration: 'underline',
            linkMenu: '#324765',
            orderConfirmationHeader: '#1f1f1b',
            orderConfirmationText: 'black',
            rewardColor: '#00488a',
            primaryButton: '#37211F', // Primary button color
            successButton: '#37211F', // Primary button color
            submit: '#333333',
            productLine: '#BDBBBB',
            modalBorder: '#ececec',
            productTitleColor: '#1f1f1b',
            productAvailibilityPDP: '#a1001a',
            sectionHeaderTextColor: '#212121',
            secondaryButton: '#757575',
            shape: {
                borderRadius: '4px',
            },
            tickCheck: '#00CC33',
            snipeText: '#660000',
            snipeTextPromo: '#a1001a',
            snipeTextBackground: 'rgba(48, 69, 98, .85)',
            snipeTextFontSize: '14px',
            snipeTextFontWeight: 500,
            guidedNav: {
                background: '#FFF',
            },
            promoGiftButtons: {
                background: '#e8eaec',
                color: '#2f2f2f',
            },
            globalBannerContainerBackground: '#ffffff',
            globalBannerContainerBorder: '#575757',
            globalBannerMainTextColor: '#2f2f2f',
            pdp: {
                subscription: {
                    checkboxColor: '#3D70B2',
                    rootContainerBackground: '#efdfb0',
                    boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
                    overlayContainerBackground: '#fff',
                    modalColor: '#fff',
                    subTable: '#f7eed7',
                    linkColor: '#304562',
                    goButton: '#a1001a',
                    goButtonColor: '#fff',
                },
            },
            mobileMenuBG: {
                header: '#909090',
                main: '#FFFDF4',
                product: '#fff',
                alternate: '#909090',
                nonProduct: '#909090',
                parent: '#909090',
                child: '#e8e8e8',
                leftMenuBG: '#a8a89a',
            },
            desktopHeaderMenu: {
                background: '#FFFDF4', // Light cream header
                text: '#333',
                border: '1px solid #f5f5f5',
                maxWidth: '1400px',
            },
            mobileMenuColor: '#fff',
            uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
            unCheckRadioBtn: '#201648',
            checkRadioBtn: '#201648',
            copyright: '#606060',
            mobileFooterBottomLink: '#201648',
            desktopBgFooter: '#FFFDF4', // Light cream footer
            modalBg: '#201648',
            modalTile: '#201648',

            cta1: '#1f1f1b', // DEPRECATED
            cta2: '#47201D', // DEPRECATED
            cta3: '#660000', // DEPRECATED
            cta4: '#595959', // DEPRECATED
            pink1: '#8E1429', // DEPRECATED
            brown1: '#47201D', // DEPRECATED
            brown2: '#DBD0C2', // DEPRECATED
            brown3: '#DBD0C2', // DEPRECATED
            grey1: '#1f1f1b', // DEPRECATED
            grey2: '#3c3c35', // DEPRECATED
            grey3: '#5c5c52', // DEPRECATED
            grey4: '#7c7c70', // DEPRECATED
            grey5: '#a8a89a', // DEPRECATED
            grey6: '#d1d1c1', // DEPRECATED
            grey7: '#ebebde', // DEPRECATED
            grey8: '#cccccc', // DEPRECATED
            grey9: '#e8eaec', // DEPRECATED
            grey10: '#b6b5b5', // DEPRECATED

            flowerGift: {
                topLogoText: {
                    color: '#000000',
                },
                titleBg: {
                    background: 'rgba(0, 0, 0, 0.1)',
                },
            },
            sympathyPage: {
                buttonColor: '#50396E',
                stickyBackground: '#fff',
                borderColors: '#ccc',
                containerWidth: '1400px',
                headingColor: '#5d3a86',
                linkColor: '#639',
                subCopyBg: '#e6e6fa',
                subCopyBorderColor: '#d8bfd8',
            },
            myAccount: {
                contentGridBorder: '#696A69',
                blockBorderRight: '#e2e2e2',
                blockMessageFadedInside: '#767775',
                blockHeaderbackground: '#ededea',
                blockActions: '#619ee6',
                caretSign: '#000',
                activeLink: '#000',
                divider: '#ccc',
                orderRow: '#f6f6f4',
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            checkoutGuestForgotLinkColor: '#3b73af',
            checkout: {
                payment: {
                    background: '#fff',
                    venmoBackgroundColor: '#3d95ce',
                },
            },
            tiers: {
                card: {
                    backgroundColor: '#fff',
                },
                image: {
                    maxWidth: '100%',
                    height: 'auto',
                },
                title: {
                    lineHeight: '42px',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    upSmall: {
                        textAlign: 'left',
                    },
                    downSmall: {
                        textAlign: 'center',
                    },
                },
                container: {
                    backgroundColor: 'transparent',
                    maxWidth: {
                        downSmall: '100%',
                        downMedium: '100%',
                        upMedium: '970px',
                        upLarge: '1170px',
                    },
                },
            },
            nup: {
                margin: '50px auto',
                header: {
                    textAlign: 'center',
                    width: '100%',
                    margin: '44px 0 20px 0',
                    letterSpacing: '.4px',
                    fontSize: '1.4em',
                    fontWeight: '300',

                },
                Standard: {
                    width: '240px',
                    height: 'auto',
                },
                Medium: {
                    width: '340px',
                    height: 'auto',
                },
                Small: {
                    width: '186px',
                },
            },
            genericBanner: {
                margin: '15px auto',
            },
            heroSingle: {
                margin: '0px auto',
            },
            footer: {
                marginTop: '10px',
                textAlign: 'left',
            },
            availableMessageColor: '#666',
            // Sympathy Helpful Resource
            ShrBordercolor: '#c0c0c0',
            sympathyViewAllBg: '#8c62ab',
            sympathyViewAllBorder: '#a3a3a3',
            sympathyAdvisorsTitle: '#6e9930',
            sympathyProductNameColor: '#666',
            sympathyAdvisorsBorder: '#b5b2d2',
            sympathyAdvisorsBg: '#f5f3f7',
            sympathyCallTitleColor: '#354219',
            passportDividerColor: '#6ecba6',
            passportBgColor: '#147a90',
            passportBorderColor: '#dcdcdc',
            passportSummaryBgColor: '#ececea',
            flowerClubColor: '#583C81',
            flowerClubBg: '#fff3ea',
            sympathyShowNowButton: '#0054a5',
            sympathyHoverColorButton: '#46a843',
            sympathyDiscountColor: '#d90059',
            // celebrations Rewards
            crBgColor: '#dddddd',
            crQusColor: '#F2A900',
            crDividerColor: '#cecece',
            crPassportTitle: '#007dba',
            crPassportSubTitle: '#999',
            sympathytitlecolor: '#70548f',
            // Promo codes Page
            imocTitleColor: '#f15a29',
            cardTitleColor: '#a4291f',
            // No Search found
            continueShoppingHoverBg: '#1D8A4E',
            backToHomeHoverBg: '#EBEBEB',
            continueShoppingBg: '#2ac670',
            // Apple Business Chat
            chatBgColor: '#e06dff',
            giftBgColor: '#4d005f',
            applePayBgColor: '#1193ff',
            // Radio Listeners Search Page
            radioOfferBestSellerBgColor: '#cdeacb',
            radioOfferBestSellerTextColor: '#ac6ab5',
            radioOfferBgColor: '#932fbd',
            motherDayBg: '#faf6f5',
            motherDayShopBtn: '#fb8966',
            // Mother's day page
            motherDayColor: '#f9394b',
            motherDayBgColor: 'rgba(0, 0, 0, .6)',
            motherWhoArrowBg: '#9dc8d6',
            motherWhoLinkColor: '#4a8ed1',
            motherWhoDescColor: '#404251',
            motherSpecialDayBgColor: '#eb537d',
            imageCardBoxShadow: 'rgba(0, 0, 0, 0.2)',
            faqBgColor: '#ffeffb',
            // Smart Gift Page
            smartGiftBgColor: '#55b74d',
            smartGiftHoverBgColor: '#1e8b4f',
            giftGuideHoverColor: '#378a4e',
            giftGuideArticleBg: '#f9f9f9',
            communitionSectionBg: '#f1f1f1',
            // Customer Serivce Page
            csBgColor: '#F5F6F9',
            csContentColor: '#f3832f',
            checkoutHeaderBg: '#201648',
            // Birthday Flowers Page
            birthdayFlowerBgColor: '#9c7eb5',
            // Footer terms and privacy
            tpColor: '#fff',
            salePriceColor: '#2e8540',
            ...twilioStyles,
            giftFinderErrorColor: '#D9001B',
            giftFinderSelectColor: '#333333',
            filterDropdownHoverColor: '#E8F1ED',
            celebrationsPaymentSummaryBackground: '#F4F4F4',
        },
        implement_delivery_method: true,
    },
};

export default brandsConfig;
